import {
	BaseModal,
	CommonModalProps,
	Container,
	InputValuesPortalProps,
	Label,
	Screen,
	useRespondTo,
} from "@animech/ui";
import { useTheme } from "@emotion/react";
import { FunctionComponent, HTMLAttributes } from "react";
import { Property } from "src/common";
import { useUiData } from "src/ui";
import { assertIsLocalizable } from "src/utility";

export type FieldValuesModalProps = CommonModalProps<
	HTMLAttributes<HTMLDivElement>
> & {
	property: Property;
	ValuesComponent: FunctionComponent<InputValuesPortalProps>;
};

export const FieldValuesModal: FunctionComponent<FieldValuesModalProps> = ({
	property,
	ValuesComponent,
	...baseProps
}) => {
	const { localizer } = useUiData();
	const { maxWidth } = useTheme().app.modals;
	const isMobile = useRespondTo("mobile");
	assertIsLocalizable(property);
	const content = (
		<Container>
			<Label>{localizer.localizeProperty(property)}</Label>
			<ValuesComponent onValueClick={baseProps.onShouldClose} />
		</Container>
	);
	return isMobile ? (
		<Screen {...baseProps}>{content}</Screen>
	) : (
		<BaseModal {...baseProps} maxWidth={maxWidth}>
			{content}
		</BaseModal>
	);
};
